export default {
  authGroups: {
    systemAdmin: {
      label: 'System administrator',
      label_other: 'System administrators',
      description: 'OF Arena system administrators',
    },
    surveyManager: {
      label: 'Survey manager',
      label_other: 'Survey managers',
      description: 'OF Arena survey managers',
    },
    surveyAdmin: {
      label: 'Survey administrator',
      label_other: 'Survey administrators',
      description: 'Full rights',
    },
    surveyEditor: {
      label: 'Survey editor',
      label_other: 'Survey editors',
      description: 'Can edit survey, records, invite users',
    },
    dataEditor: {
      label: 'Data editor',
      label_other: 'Data editors',
      description: 'Can edit records in data entry step',
    },
    dataCleanser: {
      label: 'Data cleanser',
      label_other: 'Data cleansers',
      description: 'Can edit records in data cleansing step',
    },
    dataAnalyst: {
      label: 'Data analyst',
      label_other: 'Data analysts',
      description: 'Can edit records in data analysis step',
    },
    surveyGuest: {
      label: 'Survey guest',
      label_other: 'Survey guests',
      description: 'Can view records',
    },
  },
}
